import { createApp } from 'vue';
import './style.css';
import App from './App.vue';

/* eslint @typescript-eslint/no-unsafe-call: "off" */
/* eslint @typescript-eslint/no-unsafe-assignment: "off" */
const app = createApp(App);

app.mount('#app');
